import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import maleAvatar from 'assets/images/patient-male.svg';
import femaleAvatar from 'assets/images/patient-female.svg';

import SolidButton from 'components/SolidButton';

const UsersList = ({ users, selectedUsers, handleSelectUser }) => {
  const { t } = useTranslation();

  return (
    <div className="patients-list-modal__list super-clinic-employees">
      {(users || []).map((user) => {
        const { node: curentUser } = user;
        const { name = '', gender = '', cardId = '', email = '', id = '' } = curentUser;
        const isSelected = [...selectedUsers].indexOf(id) !== -1;
        return (
          <div key={id} className="patient">
            <div className="patient__info">
              <div className="patient__info__avatar">
                <img src={gender === 'Hombre' ? maleAvatar : femaleAvatar} alt="patient avatar" />
              </div>
              <div className="patient__info__name">
                <p>{name}</p>
                <p>{cardId}</p>
                <p>{email}</p>
              </div>
            </div>
            <div>
              <SolidButton
                onClick={() => handleSelectUser(id)}
                className={`${isSelected ? 'remove' : 'add'} min-width-100 slim`}
              >
                {isSelected ? t('button.delete') : t('button.add')}
              </SolidButton>
            </div>
          </div>
        );
      })}
    </div>
  );
};

UsersList.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleSelectUser: PropTypes.func.isRequired,
};

export default UsersList;
